import React from 'react';

const Sun = props => (
  <svg width="236" height="218" viewBox="0 0 236 218" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 179V1H235L110 26L230 52H104L164 123L71 79L110 200L35 87L50 217L14 93L1 179Z" fill="#FAFF00" stroke="black" stroke-width="2"/>
  </svg>
);

export default Sun;
